import { CartContext, CartContextType } from "modules/orders"
import { useContext } from "react"

export function useCart (): CartContextType {
    return useContext( CartContext )
}
